// @generated by protoc-gen-es v2.4.0 with parameter "target=ts"
// @generated from file travel/v1/cart.proto (package travel.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv1";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv1";
import type { Passenger, Travel, UnnamedPassenger } from "./common_pb";
import { file_travel_v1_common } from "./common_pb";
import type { PlacementSeatDeck, PlacementSeatPosition, PlacementSpaceType } from "./search_pb";
import { file_travel_v1_search } from "./search_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file travel/v1/cart.proto.
 */
export const file_travel_v1_cart: GenFile = /*@__PURE__*/
  fileDesc("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", [file_travel_v1_common, file_travel_v1_search]);

/**
 * @generated from message travel.v1.AddRequest
 */
export type AddRequest = Message<"travel.v1.AddRequest"> & {
  /**
   * @generated from field: string travel_id = 1;
   */
  travelId: string;

  /**
   * @generated from field: string dap_number = 2;
   */
  dapNumber: string;

  /**
   * @generated from field: travel.v1.OfferAddRequest outward = 3;
   */
  outward?: OfferAddRequest;

  /**
   * @generated from field: travel.v1.OfferAddRequest inward = 4;
   */
  inward?: OfferAddRequest;

  /**
   * @generated from field: travel.v1.UnnamedPassenger main_passenger = 5;
   */
  mainPassenger?: UnnamedPassenger;

  /**
   * @generated from field: repeated travel.v1.Passenger additional_passengers = 6;
   */
  additionalPassengers: Passenger[];

  /**
   * @generated from field: repeated travel.v1.PlacementWish placement_wishes = 7;
   */
  placementWishes: PlacementWish[];
};

/**
 * Describes the message travel.v1.AddRequest.
 * Use `create(AddRequestSchema)` to create a new message.
 */
export const AddRequestSchema: GenMessage<AddRequest> = /*@__PURE__*/
  messageDesc(file_travel_v1_cart, 0);

/**
 * @generated from message travel.v1.PlacementWish
 */
export type PlacementWish = Message<"travel.v1.PlacementWish"> & {
  /**
   * @generated from field: string segment_id = 1;
   */
  segmentId: string;

  /**
   * @generated from oneof travel.v1.PlacementWish.wish
   */
  wish: {
    /**
     * @generated from field: travel.v1.SeatReference close_to = 2;
     */
    value: SeatReference;
    case: "closeTo";
  } | {
    /**
     * @generated from field: travel.v1.SeatReference seat_map = 3;
     */
    value: SeatReference;
    case: "seatMap";
  } | {
    /**
     * @generated from field: travel.v1.PreferredSeat preferred_seat = 4;
     */
    value: PreferredSeat;
    case: "preferredSeat";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message travel.v1.PlacementWish.
 * Use `create(PlacementWishSchema)` to create a new message.
 */
export const PlacementWishSchema: GenMessage<PlacementWish> = /*@__PURE__*/
  messageDesc(file_travel_v1_cart, 1);

/**
 * @generated from message travel.v1.SeatReference
 */
export type SeatReference = Message<"travel.v1.SeatReference"> & {
  /**
   * @generated from field: string coach = 1;
   */
  coach: string;

  /**
   * @generated from field: string seat_number = 2;
   */
  seatNumber: string;
};

/**
 * Describes the message travel.v1.SeatReference.
 * Use `create(SeatReferenceSchema)` to create a new message.
 */
export const SeatReferenceSchema: GenMessage<SeatReference> = /*@__PURE__*/
  messageDesc(file_travel_v1_cart, 2);

/**
 * @generated from message travel.v1.PreferredSeat
 */
export type PreferredSeat = Message<"travel.v1.PreferredSeat"> & {
  /**
   * @generated from field: travel.v1.PlacementSeatPosition position = 1;
   */
  position: PlacementSeatPosition;

  /**
   * @generated from field: travel.v1.PlacementSpaceType space = 2;
   */
  space: PlacementSpaceType;

  /**
   * @generated from field: travel.v1.PlacementSeatDeck deck = 3;
   */
  deck: PlacementSeatDeck;
};

/**
 * Describes the message travel.v1.PreferredSeat.
 * Use `create(PreferredSeatSchema)` to create a new message.
 */
export const PreferredSeatSchema: GenMessage<PreferredSeat> = /*@__PURE__*/
  messageDesc(file_travel_v1_cart, 3);

/**
 * @generated from message travel.v1.OfferAddRequest
 */
export type OfferAddRequest = Message<"travel.v1.OfferAddRequest"> & {
  /**
   * @generated from field: string offer_id = 1;
   */
  offerId: string;

  /**
   * @generated from field: repeated travel.v1.AncillaryToBook ancillaries = 2;
   */
  ancillaries: AncillaryToBook[];
};

/**
 * Describes the message travel.v1.OfferAddRequest.
 * Use `create(OfferAddRequestSchema)` to create a new message.
 */
export const OfferAddRequestSchema: GenMessage<OfferAddRequest> = /*@__PURE__*/
  messageDesc(file_travel_v1_cart, 4);

/**
 * @generated from message travel.v1.AncillaryToBook
 */
export type AncillaryToBook = Message<"travel.v1.AncillaryToBook"> & {
  /**
   * @generated from field: string type = 1;
   */
  type: string;

  /**
   * @generated from field: int32 quantity = 2;
   */
  quantity: number;
};

/**
 * Describes the message travel.v1.AncillaryToBook.
 * Use `create(AncillaryToBookSchema)` to create a new message.
 */
export const AncillaryToBookSchema: GenMessage<AncillaryToBook> = /*@__PURE__*/
  messageDesc(file_travel_v1_cart, 5);

/**
 * @generated from message travel.v1.AddResponse
 */
export type AddResponse = Message<"travel.v1.AddResponse"> & {
  /**
   * @generated from field: travel.v1.CartItem item = 1;
   */
  item?: CartItem;
};

/**
 * Describes the message travel.v1.AddResponse.
 * Use `create(AddResponseSchema)` to create a new message.
 */
export const AddResponseSchema: GenMessage<AddResponse> = /*@__PURE__*/
  messageDesc(file_travel_v1_cart, 6);

/**
 * @generated from message travel.v1.ListRequest
 */
export type ListRequest = Message<"travel.v1.ListRequest"> & {
};

/**
 * Describes the message travel.v1.ListRequest.
 * Use `create(ListRequestSchema)` to create a new message.
 */
export const ListRequestSchema: GenMessage<ListRequest> = /*@__PURE__*/
  messageDesc(file_travel_v1_cart, 7);

/**
 * @generated from message travel.v1.ListResponse
 */
export type ListResponse = Message<"travel.v1.ListResponse"> & {
  /**
   * @generated from field: repeated travel.v1.CartItem items = 1;
   */
  items: CartItem[];
};

/**
 * Describes the message travel.v1.ListResponse.
 * Use `create(ListResponseSchema)` to create a new message.
 */
export const ListResponseSchema: GenMessage<ListResponse> = /*@__PURE__*/
  messageDesc(file_travel_v1_cart, 8);

/**
 * @generated from message travel.v1.CartItem
 */
export type CartItem = Message<"travel.v1.CartItem"> & {
  /**
   * @generated from field: travel.v1.Travel travel = 1;
   */
  travel?: Travel;

  /**
   * @generated from field: travel.v1.ActionState action_state = 3;
   */
  actionState: ActionState;

  /**
   * @generated from field: optional travel.v1.PaymentData payment_data = 4;
   */
  paymentData?: PaymentData;
};

/**
 * Describes the message travel.v1.CartItem.
 * Use `create(CartItemSchema)` to create a new message.
 */
export const CartItemSchema: GenMessage<CartItem> = /*@__PURE__*/
  messageDesc(file_travel_v1_cart, 9);

/**
 * @generated from message travel.v1.ReleaseRequest
 */
export type ReleaseRequest = Message<"travel.v1.ReleaseRequest"> & {
  /**
   * @generated from field: string travel_id = 1;
   */
  travelId: string;
};

/**
 * Describes the message travel.v1.ReleaseRequest.
 * Use `create(ReleaseRequestSchema)` to create a new message.
 */
export const ReleaseRequestSchema: GenMessage<ReleaseRequest> = /*@__PURE__*/
  messageDesc(file_travel_v1_cart, 10);

/**
 * @generated from message travel.v1.ReleaseResponse
 */
export type ReleaseResponse = Message<"travel.v1.ReleaseResponse"> & {
};

/**
 * Describes the message travel.v1.ReleaseResponse.
 * Use `create(ReleaseResponseSchema)` to create a new message.
 */
export const ReleaseResponseSchema: GenMessage<ReleaseResponse> = /*@__PURE__*/
  messageDesc(file_travel_v1_cart, 11);

/**
 * Data needed by the front-end to process the payment
 *
 * @generated from message travel.v1.PaymentData
 */
export type PaymentData = Message<"travel.v1.PaymentData"> & {
  /**
   * @generated from field: string provider_name = 1;
   */
  providerName: string;

  /**
   * Intentionally implementation-agnostic
   *
   * @generated from field: map<string, string> data = 2;
   */
  data: { [key: string]: string };
};

/**
 * Describes the message travel.v1.PaymentData.
 * Use `create(PaymentDataSchema)` to create a new message.
 */
export const PaymentDataSchema: GenMessage<PaymentData> = /*@__PURE__*/
  messageDesc(file_travel_v1_cart, 12);

/**
 * @generated from message travel.v1.ConfirmRequest
 */
export type ConfirmRequest = Message<"travel.v1.ConfirmRequest"> & {
  /**
   * @generated from field: string travel_id = 1;
   */
  travelId: string;
};

/**
 * Describes the message travel.v1.ConfirmRequest.
 * Use `create(ConfirmRequestSchema)` to create a new message.
 */
export const ConfirmRequestSchema: GenMessage<ConfirmRequest> = /*@__PURE__*/
  messageDesc(file_travel_v1_cart, 13);

/**
 * @generated from message travel.v1.ConfirmResponse
 */
export type ConfirmResponse = Message<"travel.v1.ConfirmResponse"> & {
  /**
   * @generated from field: travel.v1.Travel confirmed_travel = 1;
   */
  confirmedTravel?: Travel;
};

/**
 * Describes the message travel.v1.ConfirmResponse.
 * Use `create(ConfirmResponseSchema)` to create a new message.
 */
export const ConfirmResponseSchema: GenMessage<ConfirmResponse> = /*@__PURE__*/
  messageDesc(file_travel_v1_cart, 14);

/**
 * @generated from enum travel.v1.ActionState
 */
export enum ActionState {
  /**
   * @generated from enum value: ACTION_STATE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: ACTION_STATE_PAYMENT_REQUIRED = 1;
   */
  PAYMENT_REQUIRED = 1,

  /**
   * @generated from enum value: ACTION_STATE_CONFIRMATION_REQUIRED = 2;
   */
  CONFIRMATION_REQUIRED = 2,

  /**
   * @generated from enum value: ACTION_STATE_COMPLETED = 3;
   */
  COMPLETED = 3,
}

/**
 * Describes the enum travel.v1.ActionState.
 */
export const ActionStateSchema: GenEnum<ActionState> = /*@__PURE__*/
  enumDesc(file_travel_v1_cart, 0);

/**
 * @generated from service travel.v1.CartService
 */
export const CartService: GenService<{
  /**
   * @generated from rpc travel.v1.CartService.Add
   */
  add: {
    methodKind: "unary";
    input: typeof AddRequestSchema;
    output: typeof AddResponseSchema;
  },
  /**
   * @generated from rpc travel.v1.CartService.List
   */
  list: {
    methodKind: "unary";
    input: typeof ListRequestSchema;
    output: typeof ListResponseSchema;
  },
  /**
   * @generated from rpc travel.v1.CartService.Release
   */
  release: {
    methodKind: "unary";
    input: typeof ReleaseRequestSchema;
    output: typeof ReleaseResponseSchema;
  },
  /**
   * @generated from rpc travel.v1.CartService.Confirm
   */
  confirm: {
    methodKind: "unary";
    input: typeof ConfirmRequestSchema;
    output: typeof ConfirmResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_travel_v1_cart, 0);

